import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FormTextArea from 'components/Form/FormTextArea/FormTextArea';
import { LabelStyled } from 'components/Input/Input.styled';

/**
 * Send message row (round corners to match card).
 * Uses a <div> instead of <form> because MessageForm is rendered inside the
 * ticket-details <form>. Nested HTML forms are invalid and the browser would
 * submit the outer form when the user clicks Send.
 */
export const FormWrapStyled = styled.div`
  display: flex;
  width: 100%;
  margin-top: 0.625rem;
  border-radius: 12px;
  overflow: hidden;

  ${LabelStyled} {
    margin-bottom: 0;
  }
`;

export const InputMessageWrapStyled = styled.div`
  flex: 1;
  margin: 0 0.625rem;
  border-radius: 12px;
  overflow: hidden;
`;
export const InputImageWrapStyled = styled.div`
  margin: 0 0.625rem;
  position: relative;
  width: fit-content;
`;

export const CloseIconBtnStyled = styled(ButtonIcon)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const StyledDragDropInput = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
`;

export const TextAreaStyled = styled(FormTextArea)`
  padding: 0.375rem 0.625rem;
  border-radius: 12px;

  color: ${({ theme }): string => theme.colors.primary.variant11};
  background-color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.primary.variant4 : theme.colors.surface};
  border-color: ${({ theme }): string => theme.colors.primary.variant6};

  &::placeholder {
    color: ${({ theme }): string => theme.colors.primary.variant8};
  }

  &:disabled {
    background-color: ${({ theme }): string => theme.colors.primary.variant5};
  }
`;

export const SendMessageBtnStyled = styled(ButtonIcon)`
  padding: 0.563rem;
  max-height: 38px;
  border-radius: 12px;
`;
